// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionRenderers__container___H9aYw {
    display: flex;
    flex-direction: row;
    gap: var(--space-xs);
    align-items: center;

    width: auto;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/model/Actions/CommonRenderers/ActionRenderers.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;;IAEnB,WAAW;AACf","sourcesContent":[".container {\n    display: flex;\n    flex-direction: row;\n    gap: var(--space-xs);\n    align-items: center;\n\n    width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ActionRenderers__container___H9aYw`
};
export default ___CSS_LOADER_EXPORT___;
